define('js/mage/menu-mixin',[
    'jquery',
    'mage/menu',
    'jquery-ui-modules/widget'
], function ($) {
    $.widget('redbox.menu', $.mage.menu, {
        options: {
            responsive: true,
            mediaBreakpoint: '(max-width: 1007px)'
        },

        _init: function () {
            this._super();

            this._toggleDesktopMode();
        },

        /**
         * @private
         */
        _toggleDesktopMode: function () {
            var categoryParent, html;

            $(this.element).off('click mousedown mouseenter mouseleave');
            this._on({

                /**
                 * Prevent focus from sticking to links inside menu after clicking
                 * them (focus should always stay on UL during navigation).
                 */
                'mousedown .ui-menu-item > a': function (event) {
                    event.preventDefault();
                },

                /**
                 * Prevent focus from sticking to links inside menu after clicking
                 * them (focus should always stay on UL during navigation).
                 */
                'click .ui-state-disabled > a': function (event) {
                    event.preventDefault();
                },

                /**
                 * @param {jQuer.Event} event
                 */
                'click .ui-menu-item:has(a)': function (event) {
                    event.preventDefault();
                    var currentActiveItem = $('.main-menu-custom__list').find('.ui-state-active').parent();
                    var target = $(event.target).closest('.ui-menu-item');

                    if (!target.hasClass('parent')) {
                        window.location.href = target.find('> a').attr('href');
                    }

                    if (!this.mouseHandled && target.not('.ui-state-disabled').length) {
                        this.select(event);

                        // Only set the mouseHandled flag if the event will bubble, see #9469.
                        if (!event.isPropagationStopped()) {
                            this.mouseHandled = true;
                        }

                        // Open submenu on click
                        if (target.has('.ui-menu').length) {
                            this.expand(event);
                        } else if (!this.element.is(':focus') &&
                            $(this.document[0].activeElement).closest('.ui-menu').length
                        ) {
                            // Redirect focus to the menu
                            this.element.trigger('focus', [true]);

                            // If the active item is on the top level, let it stay active.
                            // Otherwise, blur the active item since it is no longer visible.
                            if (this.active && this.active.parents('.ui-menu').length === 1) { //eslint-disable-line
                                clearTimeout(this.timer);
                            }
                        }
                    }
                },

                /**
                 * If we use static block for mega menu and have links inside
                 * Unbind event.preventDefault
                 */
                'click .ui-menu-item a[data-element="link"]': function (event) {
                    this.unbind('click');
                },

                /**
                 * @param {jQuery.Event} event
                 */
                'mouseenter .ui-menu-item': function (event) {
                    var target = $(event.currentTarget),
                        submenu = this.options.menus,
                        ulElement,
                        ulElementWidth,
                        width,
                        targetPageX,
                        rightBound;

                    if (target.has(submenu)) {
                        ulElement = target.find(submenu);
                        ulElementWidth = ulElement.outerWidth(true);
                        width = target.outerWidth() * 2;
                        targetPageX = target.offset().left;
                        rightBound = $(window).width();

                        if (ulElementWidth + width + targetPageX > rightBound) {
                            ulElement.addClass('submenu-reverse');
                        }

                        if (targetPageX - ulElementWidth < 0) {
                            ulElement.removeClass('submenu-reverse');
                        }
                    }

                    // Remove ui-state-active class from siblings of the newly focused menu item
                    // to avoid a jump caused by adjacent elements both having a class with a border
                    target.siblings().children('.ui-state-active').removeClass('ui-state-active');
                    this.focus(event, target);
                },

                /**
                 * @param {jQuery.Event} event
                 */
                'mouseleave': function (event) {
                    this.collapseAll(event, true);
                },

                /**
                 * Mouse leave.
                 */
                'mouseleave .ui-menu': 'collapseAll'
            });

            categoryParent = this.element.find('.all-category');
            html = $('html');

            categoryParent.remove();


            if (html.hasClass('nav-open')) {
                html.removeClass('nav-open');
                setTimeout(function () {
                    html.removeClass('nav-before-open');
                }, this.options.hideDelay);
            }

            if (!$('.level0 > .submenu').children('.desktop-close-btn').length > 0) {
                $('<div class="desktop-close-btn"><span>Close</span></div>').prependTo('.level0 > .submenu');
            }
            if ($(window).innerWidth() > 1260) {
                $('.main-menu-custom .level0 > .submenu').addClass('after-background');
            }

            if (!$('.account-links').length > 0) {
                $('.nav-sections-items').prepend('<div class="account-links"></div>')
            }

            $( window ).on('resize', function() {
                $(window).innerWidth() < 1260 ? $('.main-menu-custom .level0 > .submenu').removeClass('after-background')
                                            : $('.main-menu-custom .level0 > .submenu').addClass('after-background');
                if($(window).innerWidth() < 993) {
                    if(!$('.nav-sections-items .account-links div.account-link-item').length) {
                        $('div.account-link-item').appendTo($('.nav-sections-items .account-links'));
                    }

                    if(!$('.nav-sections-items .account-links div.carehub-section-top').length) {
                        $('div.carehub-section-top').appendTo($('.nav-sections-items .account-links'));
                        if($('body').hasClass('carehub-assisted')) {
                            $('#store\\.menu').addClass('carehub');
                        }
                    }
                }

                if ($(window).innerWidth() >= 993) {
                    if(!$('li.account-link-item div.account-link-item').length) {
                        $('li.account-link-item').append($('div.account-link-item'));
                    };

                    if(!$('li.carehub-links div.carehub-section-top').length) {
                        $('li.carehub-links').append($('div.carehub-section-top'));
                    };
                }

                $(window).innerWidth() < 993 ? $('.top-links-mobile').prepend($(".store-switcher"))
                                            : $('.header-category-wrapper').prepend($(".store-switcher"));
            });

            $('.top-links.top-left-links').removeClass('navigation');
            $('.main-menu-custom__inner-link').each(function () {
                var self = this;
                $(self).hasClass('current') &&  $(self).parent().parent().parent().parent().parent().addClass('active')
            })
            this.helpMenuUnwrapTitleLink();
            this.setCurrentItem();
        },

        /**
         * @private
         */
        _toggleMobileMode: function () {
            var subMenus,
                _self = this;

            this.helpMenuUnwrapTitleLink();
            this.setCurrentItem();

            if (!$('.nav-sections-items').children('.mobile-close-btn').length > 0) {
                $('<div class="mobile-close-btn"><span>Close</span></div>').appendTo('.nav-sections-items');
            }

            if (!$('.account-links').length > 0) {
                $('.nav-sections-items').prepend('<div class="account-links"></div>')
            }

            if (!$('.top-links-mobile').length > 0) {
                $('.nav-sections-items').prepend('<div class="top-links-mobile"></div>')
            }

            $('.nav-sections-items').prepend($('div.account-link-item'));


            if ($(window).innerWidth() >= 993) {
                if(!$('li.account-link-item div.account-link-item').length) {
                    $('li.account-link-item').append($('div.account-link-item'));
                };

                if(!$('li.carehub-links div.carehub-section-top').length) {
                    $('li.carehub-links').append($('div.carehub-section-top'));
                };
            }

            if($(window).innerWidth() < 993) {
                $('.top-links-mobile').prepend($(".store-switcher"));

                if(!$('.nav-sections-items .account-links div.account-link-item').length) {
                    $('div.account-link-item').appendTo($('.nav-sections-items .account-links'));
                }

                if(!$('.nav-sections-items .account-links div.carehub-section-top').length) {
                    $('div.carehub-section-top').appendTo($('.nav-sections-items .account-links'));
                    if($('body').hasClass('carehub-assisted')) {
                        $('#store\\.menu').addClass('carehub');
                    }
                }
            }

            $(this.element).off('mouseenter mouseleave');
            this._on({

                /**
                 * @param {jQuery.Event} event
                 */
                'click .ui-menu-item:has(a[role="menuitem"])': function (event) {
                    var target, cmsLink;

                    target = $(event.target).closest('.ui-menu-item');
                    cmsLink = target.find('> [data-content-type="row"] a[data-link-type="default"]').length;

                    if(!cmsLink) {
                        event.preventDefault();
                        target.get(0).scrollIntoView();

                        if (!target.hasClass('level-top') || !target.has('.ui-menu').length) {
                            window.location.href = target.find('> a').attr('href');
                        }
                    }
                },

                /**
                 * @param {jQuery.Event} event
                 */
                'click .ui-menu-item:has(.ui-state-active)': function (event) {
                    this.collapseAll(event, true);
                }
            });

            subMenus = this.element.find('.level-top');
            $.each(subMenus, $.proxy(function (index, item) {
                var category = $(item).find('> a').text(),
                    categoryUrl = $(item).find('> a').attr('href'),
                    menu = $(item).find('> .ui-menu');

                this.categoryLink = $('<a>')
                    .attr('href', categoryUrl)
                    .text($.mage.__('All %1').replace('%1', category));

                this.categoryParent = $('<li>')
                    .addClass('ui-menu-item all-category')
                    .html(this.categoryLink);

                if (menu.find('.all-category').length === 0) {
                    menu.prepend(this.categoryParent);
                }

                var subMenuHeader = $('<div class="submenu-header">').text(category);
                if (!menu.find('.submenu-header').length > 0) {
                    menu.prepend(subMenuHeader);
                }

            }, this));

            /**
             * Hide submenu when click back
             */
            $(document).on("click", ".submenu-header", function () {
                $(this).parent().hide()
            });

            /**
             * Toggle mobile menu
             */
            $(document).on("click", ".mobile-close-btn", function (e) {
                _self.toggle();
                e.stopImmediatePropagation();
            });
        },

        /**
         * @param {jQuery.Event} event
         */
         expand: function (event) {

            var newItem = this.active &&
                this.active
                    .children('.ui-menu')
                    .children('.ui-menu-item')
                    .first();

            if (newItem && newItem.length) {
                if (newItem.closest('.ui-menu').is(':visible') &&
                    newItem.closest('.ui-menu').has('.all-categories')
                ) {
                    return;
                }

                // remove the active state class from the siblings
                this.active.siblings().children('.ui-state-active').removeClass('ui-state-active');

                this._open(newItem.parent());

                // Delay so Firefox will not hide activedescendant change in expanding submenu from AT
                this._delay(function () {
                    this.focus(event, newItem);
                });
            }
        },

        helpMenuUnwrapTitleLink: function () {
            $('.help-menu__column-title a').contents().unwrap();
        },

        setCurrentItem: function () {

            let menu = $(this.element),
                links = menu.find('a');
                path = window.location.pathname;

            if (links.length) {
                links.each(function () {
                    if (path === $(this).attr('href')) {
                        $(this).addClass('current');
                    }
                });
            }
        }
    });
    return $.redbox.menu;
});

